import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-how-process',
        standalone: true,
imports: [RouterLink,
        TranslatePipe
    ],
    templateUrl: './how-process.component.html',
    styleUrl: './how-process.component.scss'
})
export class HowProcessComponent {
  @Input() isLoggedIn!: boolean;
  @Input() translations: any;
}
